import React, { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n, { 
  SUPPORTED_LANGUAGES, 
  getTextDirection,
  getCurrentLanguage
} from './config'
import type { SupportedLanguage } from './types'

interface I18nProviderProps {
  children: React.ReactNode
  onLanguageChange?: (language: SupportedLanguage) => void
}

export const I18nProvider: React.FC<I18nProviderProps> = ({
  children,
  onLanguageChange,
}) => {
  // Set initial direction based on current language
  useEffect(() => {
    const currentLang = getCurrentLanguage()
    const direction = getTextDirection(currentLang)
    document.documentElement.dir = direction
    document.documentElement.lang = currentLang
  }, [])

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      const supportedLng = Object.keys(SUPPORTED_LANGUAGES).includes(lng) 
        ? lng as SupportedLanguage 
        : 'en'
      
      // Update document direction when language changes
      const direction = getTextDirection(supportedLng)
      document.documentElement.dir = direction
      document.documentElement.lang = supportedLng
      
      onLanguageChange?.(supportedLng)
    }

    i18n.on('languageChanged', handleLanguageChanged)
    return () => i18n.off('languageChanged', handleLanguageChanged)
  }, [onLanguageChange])

  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  )
}

export default I18nProvider